import PropTypes from 'prop-types';
import React from 'react';

import { messages } from '../../../constants';
import * as D from '../../../deps';

import AlbumTrackList from './AlbumTrackList';

const AlbumTrackListWithLogger = D.withVisibilityLogger(
  {
    contentSection: D.Constants.ContentSections.BackstageContentSections.TRACK_LIST,
  },
  { staticHeight: D.RowItemHeights.SMALL, useMemo: true },
)(AlbumTrackList);

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
export const AlbumMainContent = props => {
  const {
    pandoraId,
    copyright,
    albumDescription,
    albumUrlPath,
    isCompilation,
    releaseType,
    tracks,
    disableHover,
  } = props;

  const AlbumDescription = albumDescription ? (
    <D.ContentSection isAlbumDescription={true}>
      <D.DescriptionBackstageWithLogger
        // @ts-expect-error TS(2322) FIXME: Type '{ text: any; linkUrl: string; isExpanded: bo... Remove this comment to see the full error message
        text={albumDescription}
        linkUrl={D.getBackstageFullDescriptionPathForShareUrl(albumUrlPath)}
        isExpanded={false}
        linkText={messages.readMore}
        disableHover={disableHover}
      />
    </D.ContentSection>
  ) : null;

  const trackListProps = {
    tracks,
    albumPandoraId: pandoraId,
    isCompilation,
    releaseType,
    elementHeight: D.RowItemHeights.SMALL,
  };

  return (
    <React.Fragment>
      {AlbumDescription}
      {/* @ts-expect-error TS(2559) FIXME: Type '{ tracks: any; albumPandoraId: any; isCompil... Remove this comment to see the full error message */}
      <AlbumTrackListWithLogger {...trackListProps} />
      {/* @ts-expect-error TS(2322) FIXME: Type '{ copyrights: any; }' is not assignable to t... Remove this comment to see the full error message */}
      {copyright && <D.CopyrightWithLogger copyrights={copyright} />}
    </React.Fragment>
  );
};

AlbumMainContent.propTypes = {
  pandoraId: PropTypes.string,
  copyright: PropTypes.string,
  albumDescription: PropTypes.string,
  albumUrlPath: PropTypes.string,
  isCompilation: PropTypes.bool,
  releaseType: PropTypes.string,
  tracks: PropTypes.array,
  disableHover: PropTypes.bool,
};

export default AlbumMainContent;
